window.addEventListener("load", function () {
  if (typeof gsap === "undefined") {
    console.error("GSAP is not loaded. Please include GSAP.");
    return;
  }

  var container = document.querySelector(".scrolling-content-container");
  var wrapper = document.querySelector(".scrolling-wrapper");
  if (!container || !wrapper) return;

  var speed = parseFloat(container.dataset.speed) || 3;
  var direction = container.dataset.direction || "left";
  var pauseOnHover = container.dataset.pause === "true";

  var originalContent = wrapper.innerHTML;

  // Temporärer Wrapper für exakte Breitenmessung
  var tempWrapper = document.createElement("div");
  tempWrapper.style.display = "flex"; // flex für gleiche Layout-Bedingungen
  tempWrapper.style.visibility = "hidden";
  tempWrapper.style.position = "absolute";
  tempWrapper.style.whiteSpace = "nowrap";
  tempWrapper.innerHTML = originalContent;
  document.body.appendChild(tempWrapper);

  var items = tempWrapper.querySelectorAll(".scroll-item");
  var totalWidth = 0;
  items.forEach(function (item) {
    var style = getComputedStyle(item);
    var width = item.offsetWidth;
    var marginRight = parseFloat(style.marginRight) || 0;
    totalWidth += width + marginRight;
  });

  document.body.removeChild(tempWrapper);

  var originalWidth = totalWidth;

  var minScrollWidth = container.clientWidth + originalWidth;
  var copiesNeeded = Math.ceil(minScrollWidth / originalWidth) + 1;

  var newContent = "";
  for (var i = 0; i < copiesNeeded; i++) {
    newContent += originalContent;
  }
  wrapper.innerHTML = newContent;

  var totalContentWidth = originalWidth * copiesNeeded;

  var xProp, modifierWrap;
  if (direction === "left") {
    xProp = "-=" + totalContentWidth;
    modifierWrap = function (x) {
      var xNum = parseFloat(x);
      return gsap.utils.wrap(-totalContentWidth, 0, xNum) + "px";
    };
  } else {
    xProp = "+=" + totalContentWidth;
    modifierWrap = function (x) {
      var xNum = parseFloat(x);
      return gsap.utils.wrap(0, totalContentWidth, xNum) + "px";
    };
  }

  var tween = gsap.to(wrapper, {
    x: xProp,
    ease: "linear",
    duration: totalContentWidth / speed,
    repeat: -1,
    modifiers: {
      x: function (x) {
        return modifierWrap(x);
      },
    },
  });

  if (pauseOnHover) {
    container.addEventListener("mouseenter", function () {
      tween.pause();
    });
    container.addEventListener("mouseleave", function () {
      tween.play();
    });
  }
});
